import { type RefObject, useEffect, useState } from 'react';

export const useIsInViewport = ({
  onEnterViewPort,
  reference,
}: {
  onEnterViewPort?: (isIntersecting: boolean) => void;
  reference: RefObject<HTMLDivElement | null>;
}) => {
  const [isIntersecting, setIsIntersecting] = useState(false);

  useEffect(() => {
    if (!reference.current) {
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      setIsIntersecting(entries.some((entry) => entry.isIntersecting));
    });

    observer.observe(reference.current);

    return () => {
      observer.disconnect();
    };
  }, [reference]);

  useEffect(() => {
    if (isIntersecting && onEnterViewPort) {
      onEnterViewPort(true);
    }
  }, [isIntersecting, onEnterViewPort]);

  return isIntersecting;
};
